import React, { Component } from 'react';
import {Image} from 'react-konva';
import cross from '../../img/cross.png';

class DeleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }

  componentDidMount() {
    const image = new window.Image();
    image.src = cross;
    image.onload = () => {
      this.setState({
        image: image
      });
    };
  }

  consoleFunc = () => {
    this.props.deleteElement(this.props.parent)
  }

  onMouseOver = () => {
    document.body.style.cursor = 'pointer';
  }

  onMouseOut = () => {
    document.body.style.cursor = 'default';
  }
  render() {
    return (
      <Image
        onMouseOver={() => this.onMouseOver()}
        onMouseOut={() => this.onMouseOut()}
        x={this.props.posx - 10}
        y={this.props.posy - 10}
        width={20}
        height={20}
        image={this.state.image}
        onClick={() => this.consoleFunc()}
        onTap={() => this.consoleFunc()}
        visible={this.props.visible}
        name={this.props.name}
      >
      </Image>
    )
  };
}

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/components/Shapes/deleteButton.js